import SearchFrom from './SearchForm';
import { FormContainer, InputWrapper, StyledInput } from './SearchForm.styles';

export { FormContainer, InputWrapper, StyledInput };
export default SearchFrom;
